import React, { useEffect, useState } from 'react';
import ToastPopup from 'web/components/ToastPopup';

function ToastPopupContainer({ toastpopup }) {
  const [active, setActive] = useState(false);
  const { popup } = toastpopup;

  useEffect(
    () => {
      console.log('container', { popup });
      if (Object.keys(popup).length > 0) setActive(true);
    },
    [popup],
  );

  return <ToastPopup message={popup?.message} show={popup?.show} />;
}

export default ToastPopupContainer;
